export default {
    dynamicFormsViewAnswers_title: "Answers",
    dynamicFormsViewAnswers_form: "Form",
    dynamicFormsViewAnswers_updatedAt: "Updated At",
    dynamicFormsViewAnswers_updatedBy: "Updated by",
    dynamicFormsViewAnswers_advancedFilters: "Pages",
    dynamicFormsViewAnswers_imageNotAvailable: "Image not available",
}